/* eslint-disable hum/restrict-constants-imports */
import {
    IncomeStatementCategory,
    OtherCategory,
} from "@/entities/DataAssociation/Account.model";
import { ACCOUNT_LIST } from "./labeling.constants";
import { StatementType } from "@/entities/DataAssociation/File.model";

export const incomeStatementAccounts = Object.values(ACCOUNT_LIST).filter(
    (account) =>
        account.statementType === StatementType.INCOME_STATEMENT ||
        account.statementType === StatementType.MIXED,
);
export const incomeStatementAccountsByCategory = {
    [IncomeStatementCategory.REVENUES]: incomeStatementAccounts.filter(
        (account) => account.category === IncomeStatementCategory.REVENUES,
    ),
    [IncomeStatementCategory.EXPENSES]: incomeStatementAccounts.filter(
        (account) => account.category === IncomeStatementCategory.EXPENSES,
    ),
    [IncomeStatementCategory.INVESTMENTS]: incomeStatementAccounts.filter(
        (account) => account.category === IncomeStatementCategory.INVESTMENTS,
    ),
    [IncomeStatementCategory.BOOKINGS]: incomeStatementAccounts.filter(
        (account) => account.category === IncomeStatementCategory.BOOKINGS,
    ),
    [IncomeStatementCategory.FINANCING]: incomeStatementAccounts.filter(
        (account) => account.category === IncomeStatementCategory.FINANCING,
    ),
    [IncomeStatementCategory.GROSS_CASHFLOWS]: incomeStatementAccounts.filter(
        (account) =>
            account.category === IncomeStatementCategory.GROSS_CASHFLOWS,
    ),
    [OtherCategory.REPORTED]: incomeStatementAccounts.filter(
        (account) => account.category === OtherCategory.REPORTED,
    ),
    [IncomeStatementCategory.OTHER_INCOME_EXPENSE_NET]:
        incomeStatementAccounts.filter(
            (account) =>
                account.category ===
                IncomeStatementCategory.OTHER_INCOME_EXPENSE_NET,
        ),
    [OtherCategory.EXCLUDED]: incomeStatementAccounts.filter(
        (account) => account.category === OtherCategory.EXCLUDED,
    ),
};
